// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","icon":"Footer_icon__RWVrh"};